import { BLOG_BY_SLUG } from "@/apollo/queries";
import Loader from "@/components/Loader";
import Banner from "@/components/Banner";
import { gql, useQuery } from "@apollo/client";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Container, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import React from "react";
import ReactMarkdown from "react-markdown";
import Image from "next/image";
import SEOHead from "@/components/SEO";

const SingleBlog = () => {
  const router = useRouter();
  const { slug } = router.query;

  const { loading, error, data } = useQuery(BLOG_BY_SLUG, {
    variables: {
      filters: {
        slug: {
          eq: slug,
        },
      },
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    console.error(error);
    return null;
  }

  const {
    Description,
    SEO,
    Image: BannerImage,
    Title,
    Contact_Us,
  } = data.blogs.data[0]?.attributes;

  return (
    <>
    <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Box as={Container} maxW="7xl" pt={{base:10,md:14}} px={{ base: 5,md: 8, xl:5}}>
        <Box textAlign={"center"}>
          <Image
            className="blog_image_detail"
            width={800}
            height={280}
            src={
              process.env.NEXT_PUBLIC_SERVER_URL +
              BannerImage?.data?.attributes.url
            }
            alt={BannerImage?.data?.attributes.name}
            style={{height:"full",cursor:"pointer"}}
          />
          <Text
            my={10}
            fontSize={{base:"2xl",md:"3xl",lg:"4xl"}}
            fontWeight={"medium"}
            color={"blue.10"}
            pos={"relative"}
            width={"100%"}
            _after={{
              content: '""',
              position: "absolute",
              color: "blue.10",
              width: "100px",
              height: "3px",
              bg: "orange.10",
              bottom: "-10px",
              left: "0",
              right: "0",
              m: "auto",
            }}
          >
            {Title}
          </Text>
        </Box>
        <ReactMarkdown
          fontSize={"md"}
          fontWeight={"normal"}
          color={"gray.10"}
          className="technologies_info"
          children={Description}
        />
      </Box>
      <Banner
        data={Contact_Us}
        classNameparent="bottom-banner"
        classNamechild
      />
    </>
  );
};

export default SingleBlog;
